<ng-container *ngIf="!iconOnly">
  <mat-form-field [appearance]="appearance" class="w-datetime-range">
    <div class="d-flex align-items-center">
      <mat-icon
        matSuffix
        (click)="onIconClick($event)"
        class="ngx-daterangepicker-action cursor"
        [class.disabled]="isDisabled"
        >date_range</mat-icon
      >
      <input
        matInput
        ngxDaterangepickerMd
        type="text"
        class="disable"
        readonly
        [(ngModel)]="value"
        [autoApply]="autoApply"
        [closeOnAutoApply]="closeOnAutoApply"
        [linkedCalendars]="linkedCalendars"
        [minDate]="minDate"
        [maxDate]="maxDate"
        [showDropdowns]="showDropdowns"
        [showWeekNumbers]="showWeekNumbers"
        [showISOWeekNumbers]="showISOWeekNumbers"
        [showClearButton]="showClearButton"
        [showCancel]="showCancel"
        [dateLimit]="dateLimit"
        [placeholder]="placeholder"
        [showCustomRangeLabel]="showCustomRangeLabel"
        [alwaysShowCalendars]="alwaysShowCalendars"
        [keepCalendarOpeningWithRange]="keepCalendarOpeningWithRange"
        [showRangeLabelOnInput]="showRangeLabelOnInput"
        [customRangeDirection]="customRangeDirection"
        [lockStartDate]="lockStartDate"
        [timePicker]="timePicker"
        [timePicker24Hour]="timePicker24Hour"
        [timePickerIncrement]="timePickerIncrement"
        [timePickerSeconds]="timePickerSeconds"
        [firstMonthDayClass]="firstMonthDayClass"
        [lastMonthDayClass]="lastMonthDayClass"
        [emptyWeekRowClass]="emptyWeekRowClass"
        [emptyWeekColumnClass]="emptyWeekColumnClass"
        [lastDayOfPreviousMonthClass]="lastDayOfPreviousMonthClass"
        [firstDayOfNextMonthClass]="firstDayOfNextMonthClass"
        [opens]="opens"
        [drops]="drops"
        [locale]="locale"
        [ranges]="ranges"
        (datesUpdated)="onDatesUpdated($event)"
        (rangeClicked)="onRangeClicked($event)"
        [disabled]="isDisabled"
        (clearClicked)="onClearClicked()"
        [isInvalidDate]="disableFutureDates"
      />
    </div>
    <ng-content select="[validation]"></ng-content>
  </mat-form-field>
</ng-container>

<ng-container *ngIf="iconOnly">
  <div class="custom-icon-calendar">
    <mat-icon
      (click)="onIconClick($event)"
      class="ngx-daterangepicker-action cursor"
      [class.disabled]="isDisabled"
      >date_range</mat-icon
    >
    <input
      class="hidden-input"
      ngxDaterangepickerMd
      type="text"
      readonly
      [(ngModel)]="value"
      [autoApply]="autoApply"
      [closeOnAutoApply]="closeOnAutoApply"
      [linkedCalendars]="linkedCalendars"
      [minDate]="minDate"
      [maxDate]="maxDate"
      [showDropdowns]="showDropdowns"
      [showWeekNumbers]="showWeekNumbers"
      [showISOWeekNumbers]="showISOWeekNumbers"
      [showClearButton]="showClearButton"
      [showCancel]="showCancel"
      [dateLimit]="dateLimit"
      [placeholder]="placeholder"
      [showCustomRangeLabel]="showCustomRangeLabel"
      [alwaysShowCalendars]="alwaysShowCalendars"
      [keepCalendarOpeningWithRange]="keepCalendarOpeningWithRange"
      [showRangeLabelOnInput]="showRangeLabelOnInput"
      [customRangeDirection]="customRangeDirection"
      [lockStartDate]="lockStartDate"
      [timePicker]="timePicker"
      [timePicker24Hour]="timePicker24Hour"
      [timePickerIncrement]="timePickerIncrement"
      [timePickerSeconds]="timePickerSeconds"
      [firstMonthDayClass]="firstMonthDayClass"
      [lastMonthDayClass]="lastMonthDayClass"
      [emptyWeekRowClass]="emptyWeekRowClass"
      [emptyWeekColumnClass]="emptyWeekColumnClass"
      [lastDayOfPreviousMonthClass]="lastDayOfPreviousMonthClass"
      [firstDayOfNextMonthClass]="firstDayOfNextMonthClass"
      [opens]="opens"
      [drops]="drops"
      [locale]="locale"
      [ranges]="ranges"
      (datesUpdated)="onDatesUpdated($event)"
      (rangeClicked)="onRangeClicked($event)"
      [disabled]="isDisabled"
      (clearClicked)="onClearClicked()"
      [isInvalidDate]="disableFutureDates"
    />
  </div>
</ng-container>